// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/accept_vision_invite.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionMemberRole } from "./vision_membership_pb";
import { file_vision_membership_v1_vision_membership } from "./vision_membership_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/accept_vision_invite.proto.
 */
export const file_vision_membership_v1_accept_vision_invite: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vbWVtYmVyc2hpcC92MS9hY2NlcHRfdmlzaW9uX2ludml0ZS5wcm90bxIbcHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxIoMBChlBY2NlcHRWaXNpb25JbnZpdGVSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5BY2NlcHRWaXNpb25JbnZpdGVSZXF1ZXN0LlBhcmFtcxoXCgZQYXJhbXMSDQoFdG9rZW4YASABKAki9gEKGkFjY2VwdFZpc2lvbkludml0ZVJlc3BvbnNlEk4KBnJlc3VsdBgBIAEoCzI+LnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5BY2NlcHRWaXNpb25JbnZpdGVSZXNwb25zZS5SZXN1bHQahwEKBlJlc3VsdBISCgpwcm9qZWN0X2lkGAEgASgJEhQKDHByb2plY3RfbmFtZRgCIAEoCRI7CgRyb2xlGAMgASgOMi0ucHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxLlZpc2lvbk1lbWJlclJvbGUSFgoOYWxyZWFkeV9tZW1iZXIYBCABKAhiBnByb3RvMw", [file_vision_membership_v1_vision_membership]);

/**
 * @generated from message protos.vision.membership.v1.AcceptVisionInviteRequest
 */
export type AcceptVisionInviteRequest = Message<"protos.vision.membership.v1.AcceptVisionInviteRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.AcceptVisionInviteRequest.Params params = 1;
   */
  params?: AcceptVisionInviteRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.AcceptVisionInviteRequest.
 * Use `create(AcceptVisionInviteRequestSchema)` to create a new message.
 */
export const AcceptVisionInviteRequestSchema: GenMessage<AcceptVisionInviteRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_accept_vision_invite, 0);

/**
 * @generated from message protos.vision.membership.v1.AcceptVisionInviteRequest.Params
 */
export type AcceptVisionInviteRequest_Params = Message<"protos.vision.membership.v1.AcceptVisionInviteRequest.Params"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message protos.vision.membership.v1.AcceptVisionInviteRequest.Params.
 * Use `create(AcceptVisionInviteRequest_ParamsSchema)` to create a new message.
 */
export const AcceptVisionInviteRequest_ParamsSchema: GenMessage<AcceptVisionInviteRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_accept_vision_invite, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.AcceptVisionInviteResponse
 */
export type AcceptVisionInviteResponse = Message<"protos.vision.membership.v1.AcceptVisionInviteResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.AcceptVisionInviteResponse.Result result = 1;
   */
  result?: AcceptVisionInviteResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.AcceptVisionInviteResponse.
 * Use `create(AcceptVisionInviteResponseSchema)` to create a new message.
 */
export const AcceptVisionInviteResponseSchema: GenMessage<AcceptVisionInviteResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_accept_vision_invite, 1);

/**
 * @generated from message protos.vision.membership.v1.AcceptVisionInviteResponse.Result
 */
export type AcceptVisionInviteResponse_Result = Message<"protos.vision.membership.v1.AcceptVisionInviteResponse.Result"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string project_name = 2;
   */
  projectName: string;

  /**
   * @generated from field: protos.vision.membership.v1.VisionMemberRole role = 3;
   */
  role: VisionMemberRole;

  /**
   * @generated from field: bool already_member = 4;
   */
  alreadyMember: boolean;
};

/**
 * Describes the message protos.vision.membership.v1.AcceptVisionInviteResponse.Result.
 * Use `create(AcceptVisionInviteResponse_ResultSchema)` to create a new message.
 */
export const AcceptVisionInviteResponse_ResultSchema: GenMessage<AcceptVisionInviteResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_accept_vision_invite, 1, 0);

